import { render, staticRenderFns } from "./addresset.vue?vue&type=template&id=168f8e93&scoped=true&"
import script from "./addresset.vue?vue&type=script&lang=js&"
export * from "./addresset.vue?vue&type=script&lang=js&"
import style0 from "./addresset.vue?vue&type=style&index=0&id=168f8e93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f8e93",
  null
  
)

export default component.exports